import { render } from "./App.vue?vue&type=template&id=59d61287"
const script = {}

import "./App.vue?vue&type=style&index=0&id=59d61287&lang=scss"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__